import { pipe, applySpec, prop, cond, equals, T, ifElse, has } from 'ramda';

import {
  ID,
  DATE,
  TARIFF_TYPE,
  CODE,
  NAME,
  NAME_UVG,
  DESCRIPTION,
  BODY_LOCATION,
  LEFT,
  RIGHT,
  SESSION,
  QUANTITY,
  SUB_TARMED,
} from 'store/invoices';
import { LAW_TYPE_KINDS } from 'store/patients';

export const headerFields = [
  { id: TARIFF_TYPE, content: 'Typ', width: '11%' },
  { id: CODE, content: 'Code', width: '12%' },
  { id: NAME, content: 'Name', width: '60%' },
  { id: BODY_LOCATION, content: 'Auge', width: '17%' },
];

export const headerSelectedFields = [
  { id: SESSION, content: 'Session', width: '15%' },
  { id: DATE, content: 'Datum', width: '20%' },
  { id: 'time', content: 'zeit', width: '10%' },
  { id: TARIFF_TYPE, content: 'Typ', width: '10%' },
  { id: CODE, content: 'Code', width: '15%' },
  { id: BODY_LOCATION, content: 'Auge', width: '15%' },
  { id: QUANTITY, content: 'Menge', width: '15%' },
].map((item) => ({ ...item, withoutSort: true }));

export const prepareServices = (services, lawType) =>
  services.map(
    applySpec({
      id: prop(ID),
      tariffType: prop(TARIFF_TYPE),
      code: prop(CODE),
      name: ifElse(
        has(SUB_TARMED),
        ifElse(() => lawType !== LAW_TYPE_KINDS.KVG, prop(NAME_UVG), prop(NAME)),
        prop(DESCRIPTION)
      ),
      bodyLocation: pipe(
        prop(BODY_LOCATION),
        cond([
          [equals(LEFT), () => 'OS'],
          [equals(RIGHT), () => 'OD'],
          [T, () => 'Beide'],
        ])
      ),
    })
  );

export const prepareSelectedServices = (services, errors, lawType) =>
  services.map((service, index) =>
    applySpec({
      id: ({ [ID]: id }) => `${id}-${index}`,
      index: () => index,
      date: prop(DATE),
      tariffType: prop(TARIFF_TYPE),
      code: prop(CODE),
      name: ifElse(
        has(SUB_TARMED),
        ifElse(() => lawType !== LAW_TYPE_KINDS.KVG, prop(NAME_UVG), prop(NAME)),
        prop(DESCRIPTION)
      ),
      bodyLocation: pipe(
        prop(BODY_LOCATION),
        cond([
          [equals(LEFT), () => 'OS'],
          [equals(RIGHT), () => 'OD'],
          [T, () => 'Beide'],
        ])
      ),
      quantity: prop(QUANTITY),
      compareError: () => Boolean(errors[index]),
      session: prop(SESSION),
    })(service)
  );
